module.exports = __webpack_public_path__ + "static/img/3.2e04a58a.png";